'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { Alert } from '@algoacademy/design-system/web/feedback/Alert/Alert';
import { AlertActions } from '@algoacademy/design-system/web/feedback/Alert/AlertActions';
import { AlertBody } from '@algoacademy/design-system/web/feedback/Alert/AlertBody';
import { AlertDescription } from '@algoacademy/design-system/web/feedback/Alert/AlertDescription';
import { AlertTitle } from '@algoacademy/design-system/web/feedback/Alert/AlertTitle';
type DropDiscountConfirmAlertProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
  /**
   * The discount this offer would wipe, as the one sentence formatDiscountSummary
   * already produces - this component never builds its own.
   */
  discountSummary: string;
};

/**
 * The step between submitting a full-price offer and actually sending it, for
 * the one case that otherwise loses something silently: a student who already
 * has a discount on their unpaid offer. The offer is updated in place and
 * keeps its id, so the link the buyer already has keeps working - but issuing
 * it at list price overwrites the discount columns outright, so from that
 * moment the same link charges full price. Staff sees that before it happens,
 * the same courtesy ChangeMentoringConfirmAlert already extends to a
 * subscription change.
 */
export function DropDiscountConfirmAlert(t0) {
  const $ = _c(20);
  const {
    isOpen,
    onClose,
    onConfirm,
    isPending,
    discountSummary
  } = t0;
  let t1;
  if ($[0] !== onClose) {
    t1 = <AlertTitle handleIsOpen={onClose}>Zniżka ucznia zniknie</AlertTitle>;
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== discountSummary) {
    t2 = <AlertDescription>Ten uczeń ma zniżkę na nieopłaconej ofercie: {discountSummary}</AlertDescription>;
    $[2] = discountSummary;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <AlertBody><p className="text-contentSecondary text-sm">Link, który uczeń już ma, zostaje ten sam i nadal działa - ale od teraz zapłaci z niego pełną cenę z cennika, bez zniżki.</p></AlertBody>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isPending || $[6] !== onClose) {
    t4 = <Button plain={true} type="button" onClick={onClose} disabled={isPending}>Anuluj</Button>;
    $[5] = isPending;
    $[6] = onClose;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isPending || $[9] !== onConfirm) {
    t5 = <Button type="button" onClick={onConfirm} loading={isPending}>Wystaw bez zniżki</Button>;
    $[8] = isPending;
    $[9] = onConfirm;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <AlertActions>{t4}{t5}</AlertActions>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== isOpen || $[15] !== onClose || $[16] !== t1 || $[17] !== t2 || $[18] !== t6) {
    t7 = <Alert open={isOpen} onClose={onClose} size="lg">{t1}{t2}{t3}{t6}</Alert>;
    $[14] = isOpen;
    $[15] = onClose;
    $[16] = t1;
    $[17] = t2;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}